import { axiosGet, axiosPost } from "../../react_axios/Axios";
import {
  CLIENT_ADD_ACTION_TYPE,
  CLIENT_DELETE_ACTION_TYPE,
  CLIENT_DETAIL_ACTION_TYPE,
  CLIENT_LIST_ACTION_TYPE,
  clientAddUrl,
  clientDeleteUrl,
  clientDetailUrl,
  clientListUrl,
  headers,
} from "../../utils/constants";

export const client_list_action =
  (
    CompanyName,
    ContactPerson,
    Designation,
    PrimaryEmailID,
    CountryID,StatusID
  ) =>
  async (dispatch) => {
    try {
      const mapdata = {
        userId:  sessionStorage.getItem("userId") == "" ||
        sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
        CompanyName: CompanyName.toString().trim(),
        ContactPerson: ContactPerson.toString().trim(),
        Designation: Designation.toString().trim(),
        PrimaryEmailID: PrimaryEmailID.toString().trim(),
        CountryID: CountryID,
        StatusID: StatusID,
      };
      const params = {
        userId: mapdata.userId === "" ? null : mapdata.userId,
        CompanyName: mapdata.CompanyName === "" ? null : mapdata.CompanyName,
        ContactPerson:
          mapdata.ContactPerson === "" ? null : mapdata.ContactPerson,
        Designation: mapdata.Designation === "" ? null : mapdata.Designation,
        PrimaryEmailID:
          mapdata.PrimaryEmailID === "" ? null : mapdata.PrimaryEmailID,
        CountryID: mapdata.CountryID === "" ? null : mapdata.CountryID,
        StatusID: mapdata.StatusID === "" ? null : mapdata.StatusID,
      };
      console.log("Client List mapdata...", mapdata);
      const res = await axiosGet(clientListUrl, params,headers);
      console.log("Client List", res);
      dispatch({
        type: CLIENT_LIST_ACTION_TYPE,
        payload: res,
      });
      return res; // No need to wrap in Promise.resolve()
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const client_detail_action = (ClientID) => async (dispatch) => {
  try {
    const params = {
      userId: sessionStorage.getItem("userId"),
      ClientID: ClientID,
    };
    console.log("Clients detail mapdata...", params);
    const res = await axiosGet(clientDetailUrl, params,headers);
    console.log("detailsClient", res);
    dispatch({
      type: CLIENT_DETAIL_ACTION_TYPE,
      payload: res,
    });
    return res; // No need to wrap in Promise.resolve()
  } catch (err) {
    return Promise.reject(err);
  }
};

export const client_add_action =
  (
    ClientID,
    firstName,
    lastName,
    designation,
    companyName,
    addressLine1,
    addressLine2,
    cityId,
    stateId,
    countryId,
    pincode,
    Mobile1,
    Mobile2,
    TelephoneNumber,
    primaryEmailID,
    secondaryEmailID,
    website,
    SameAsAbove,
    SAAFirstName,
    SAALastName,
    SAADesignation,
    SAACompanyName,
    SAAAddressLine1,
    SAAAddressLine2,
    SAACityId,
    SAAStateId,
    SAACountryId,
    SAAPincode,
    SAAMobile1,
    SAAMobile2,
    SAATelephoneNumber,
    SAAPrimaryEmailID,
    SAASecondaryEmailID,
    SAAWebsite,
    registrationNumber,
    PANCardNo,
    NameonPANCard,
    GSTNo,
    TANNumber,
    UINNumber,
    accountName,
    accountNo,
    accountType,
    bankName,
    branchName,
    IFSCCode,
    EventCordinatorName,
    EventCordinatorDesignation,
    EventCordinatorEmail,
    EventCordinatorMobile,
    PrimaryContactName,
    PrimaryContactDesignation,
    PrimaryContactEmail,
    PrimaryContactMobile,adminCompanyInfoUpdate,StatusID
  ) =>
  async (dispatch) => {
    try {
      const mapdata = {
        UserID: parseInt(sessionStorage.getItem("userId")),
        ClientID: ClientID != "" ? ClientID : null,
        FirstName: firstName != "" ? firstName : null,
        LastName: lastName != "" ? lastName : null,
        Designation: designation != "" ? designation : null,
        CompanyName: companyName != "" ? companyName : null,
        AddressLine1: addressLine1 != "" ? addressLine1 : null,
        AddressLine2: addressLine2 != "" ? addressLine2 : null,
        CityID: cityId != "" ? cityId : null,
        StateID: stateId != "" ? stateId : null,
        Countryid: countryId != "" ? countryId : null,
        Pincode: pincode != "" ? pincode : null,
        Mobile1: Mobile1 != "" ? Mobile1 : null,
        Mobile2: Mobile2 != "" ? Mobile2 : null,
        Telephone: TelephoneNumber != "" ? TelephoneNumber : null,
        PrimaryEmailID: primaryEmailID != "" ? primaryEmailID : null,
        SecondaryEmailID: secondaryEmailID != "" ? secondaryEmailID : null,
        Website: website != "" ? website : null,
        IS_SameAsAbove: SameAsAbove != "" ? SameAsAbove : false,
        Inv_FirstName: SAAFirstName != "" ? SAAFirstName : null,
        Inv_LastName: SAALastName != "" ? SAALastName : null,
        Inv_Designation: SAADesignation != "" ? SAADesignation : null,
        Inv_CompanyName: SAACompanyName != "" ? SAACompanyName : null,
        Inv_AddressLine1: SAAAddressLine1 != "" ? SAAAddressLine1 : null,
        Inv_AddressLine2: SAAAddressLine2 != "" ? SAAAddressLine2 : null,
        Inv_CityID: SAACityId != "" ? SAACityId : null,
        Inv_StateID: SAAStateId != "" ? SAAStateId : null,
        Inv_Countryid: SAACountryId != "" ? SAACountryId : null,
        Inv_Pincode: SAAPincode != "" ? SAAPincode : null,
        Inv_Mobile1: SAAMobile1 != "" ? SAAMobile1 : null,
        Inv_Mobile2: SAAMobile2 != "" ? SAAMobile2 : null,
        Inv_Telephone: SAATelephoneNumber != "" ? SAATelephoneNumber : null,
        Inv_PrimaryEmailID: SAAPrimaryEmailID != "" ? SAAPrimaryEmailID : null,
        Inv_SecondaryEmailID:
          SAASecondaryEmailID != "" ? SAASecondaryEmailID : null,
        Inv_Website: SAAWebsite != "" ? SAAWebsite : null,
        CompanyRegistrationNo:
          registrationNumber != "" ? registrationNumber : null,
        PanNo: PANCardNo != "" ? PANCardNo : null,
        NameOnPanCard: NameonPANCard != "" ? NameonPANCard : null,
        GSTNo: GSTNo != "" ? GSTNo : null,
        TanNo: TANNumber != "" ? TANNumber : null,
        UINNo: UINNumber != "" ? UINNumber : null,
        AccountName: accountName != "" ? accountName : null,
        AccountNo: accountNo != "" ? accountNo : null,
        AccountType: accountType != "" ? accountType : null,
        BankName: bankName != "" ? bankName : null,
        BranchName: branchName != "" ? branchName : null,
        IFSCCode: IFSCCode != "" ? IFSCCode : null,
        EventCordinatorName: EventCordinatorName,
        EventCordinatorDesignation: EventCordinatorDesignation,
        EventCordinatorEmail: EventCordinatorEmail,
        EventCordinatorMobile: EventCordinatorMobile,
        PrimaryContactName: PrimaryContactName,
        PrimaryContactDesignation: PrimaryContactDesignation,
        PrimaryContactEmail: PrimaryContactEmail,
        PrimaryContactMobile: PrimaryContactMobile,
        adminCompanyInfoUpdate:adminCompanyInfoUpdate==1?adminCompanyInfoUpdate:null,
        StatusID:StatusID
      };
      console.log("Events add mapdata...", mapdata);

      const res = await axiosPost(clientAddUrl, mapdata, headers);
      dispatch({
        type: CLIENT_ADD_ACTION_TYPE,
        payload: res,
      });
      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };
export const client_delete_action = (userId, ClientID) => async (dispatch) => {
  try {
    const mapdata = {
      userId:  sessionStorage.getItem("userId") == "" ||
        sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
      ClientID: ClientID,
    };

    const res = await axiosGet(clientDeleteUrl, mapdata,headers);
    dispatch({
      type: CLIENT_DELETE_ACTION_TYPE,
      payload: res,
    });
    return Promise.resolve(res);
  } catch (err) {
    return Promise.reject(err);
  }
};
